/* eslint-disable no-unused-vars */
import { React } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Grid,
  Typography
} from '@material-ui/core';
import SessionFormationResultTable from './SessionFormationResultTable';
import { getSessionKanbanStatus } from './SessionFormationsKanban';
import moment from 'moment';

export const applyFilters = (sessionsFormation, filters) => {
  if (!filters) return sessionsFormation;

  return sessionsFormation.filter((formation) => {
    if (formation.name === null) return false;

    // 1. Barre de recherche (Nom ou N° Programme automatiquement)
    if (filters.searchQuery && filters.searchQuery.trim() !== '') {
      const query = filters.searchQuery.toLowerCase().trim();
      const name = formation.name ? formation.name.toLowerCase() : '';
      const progNo = formation.program_number ? formation.program_number.toLowerCase() : '';
      
      if (!name.includes(query) && !progNo.includes(query)) {
        return false;
      }
    }

    // 1b. Filtre Statut (calculé comme les colonnes du Kanban)
    if (filters.status) {
      if (getSessionKanbanStatus(formation) !== filters.status) return false;
    }

    // 2. Filtre Format
    if (filters.format) {
      const fmt = formation.format || '';
      if (fmt.toLowerCase() !== filters.format.toLowerCase()) return false;
    }

    // 3. Filtre Type d'action
    if (filters.actionType) {
      const act = formation.action_type || '';
      if (act.toLowerCase() !== filters.actionType.toLowerCase()) return false;
    }

    // 4. Filtre Professions
    if (filters.profession) {
      const profs = formation.professions
        ? formation.professions.split(',').map((p) => p.trim().toLowerCase())
        : [];
      if (!profs.includes(filters.profession.toLowerCase())) return false;
    }

    // 5. Filtre Année
    if (filters.year) {
      if (formation.start_date) {
        const parts = formation.start_date.split('/');
        if (parts.length === 3) {
          const sessionYear = parts[2];
          if (sessionYear !== filters.year) return false;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    // 6. Filtre Mois
    if (filters.month) {
      if (formation.start_date) {
        const parts = formation.start_date.split('/');
        if (parts.length === 3) {
          const sessionMonth = parseInt(parts[1], 10);
          if (sessionMonth !== filters.month) return false;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    // 7. Date début ≥ (startDateMin, format JJ/MM/AAAA)
    if (filters.startDateMin && filters.startDateMin.trim() !== '') {
      const minDate = moment(filters.startDateMin.trim(), 'DD/MM/YYYY', true);
      if (minDate.isValid()) {
        const sessionDate = moment(formation.start_date, 'DD/MM/YYYY', true);
        if (sessionDate.isValid()) {
          if (sessionDate.isBefore(minDate, 'day')) return false;
        } else {
          return false;
        }
      }
    }

    // 8. Date début ≤ (startDateMax, format JJ/MM/AAAA)
    if (filters.startDateMax && filters.startDateMax.trim() !== '') {
      const maxDate = moment(filters.startDateMax.trim(), 'DD/MM/YYYY', true);
      if (maxDate.isValid()) {
        const sessionDate = moment(formation.start_date, 'DD/MM/YYYY', true);
        if (sessionDate.isValid()) {
          if (sessionDate.isAfter(maxDate, 'day')) return false;
        } else {
          return false;
        }
      }
    }

    return true;
  });
};

const SessionFormationsResults = (props) => {
  const { sessionsFormation, filters, setSessionsFormation, ...other } = props;

  const filteredFormations = applyFilters(sessionsFormation, filters);

  return (
    <div>
      <Box
        {...other}
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          mb: 2
        }}
      >
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: '1.2rem',
            color: 'text.primary',
            letterSpacing: '-0.02em',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            mb: { xs: 2, sm: 0 },
            '&:after': {
              backgroundColor: 'secondary.main',
              bottom: '-8px',
              content: '" "',
              height: '3px',
              left: 0,
              position: 'absolute',
              borderRadius: '2px',
              width: '32px'
            }
          }}
        >
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: 'secondary.main', display: 'inline-block', boxShadow: (theme) => `0 0 8px ${theme.palette.secondary.main}` }} />
          Il y a {filteredFormations.filter((ff) => ff.name !== null).length} session{filteredFormations.filter((ff) => ff.name !== null).length > 1 ? 's' : ''}
        </Typography>
      </Box>
      <Grid>
        <SessionFormationResultTable
          sessionsFormation={filteredFormations}
          setSessionsFormation={setSessionsFormation}
        />
      </Grid>
    </div>
  );
};

SessionFormationsResults.propTypes = {
  sessionsFormation: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  setSessionsFormation: PropTypes.func.isRequired
};

export default SessionFormationsResults;
